var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#41505F",
  fillRule: "nonzero",
  d: "M14.459 15.915c-.781-.417-.364-1.199 0-1.563.469-.469 1.042-2.083 1.042-2.083.938-.417 1.042-1.094 1.146-1.562.417-1.355-.625-1.563-.625-1.563s.833-2.239.156-3.958c-.886-2.239-4.48-3.073-5.105-.989-4.27-.938-3.386 4.946-3.386 4.946s-1.041.208-.625 1.563c.105.468.209 1.145 1.146 1.562 0 0 .573 1.614 1.042 2.083.364.364.781 1.146 0 1.563C7.688 16.747 3 16.956 3 20.6h17.708c.001-3.645-4.686-3.853-6.249-4.686"
})));
export { SvgProfile as ReactComponent };
export default __webpack_public_path__ + "static/media/profile.ff8e3ec4.svg";